import React from "react";
import { ProgressPie } from "@activecollab/components";
import PropTypes from "prop-types";

//@todo proveriti da li boje rade u svim browserima
export const getProgressColor = (percent, lowLevel = 50, highLevel = 75, criticalLevel = 90, transparent = false) => {
  if (percent >= lowLevel && percent < highLevel) {
    return transparent ? "color-mix(in srgb, var(--warning), transparent 75%)" : "var(--warning)";
  }
  if (percent >= highLevel && percent < criticalLevel) {
    return transparent ? "color-mix(in srgb, var(--color-sucess-green), transparent 50%)" : "var(--color-sucess-green)";
  }
  return transparent ? "color-mix(in srgb, var(--red-alert), transparent 75%)" : "var(--red-alert)";
};
export const UtilizationPie = ({ utilization, radius, className }) => {
  return (
    <ProgressPie
      radius={radius}
      progress={utilization}
      className={className}
      progressColor={getProgressColor(utilization)}
    />
  );
};

UtilizationPie.propTypes = {
  utilization: PropTypes.number,
  radius: PropTypes.number,
  className: PropTypes.string,
};

UtilizationPie.defaultProps = {
  utilization: 0,
  radius: 6,
};
